export default __webpack_public_path__ + "static/media/gameIndustry.e387e33c.jpg";